// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"266":"e05040e2","453":"5d4696ea"}[chunkId] + ".chunk.js";
};